var Code, DOCUMENT_SECTIONS_V2_SECTION_TYPE, EditingByInfo, SECTION_STATUSES, arrayOf, boolean, convertFromStringIfNecessary, createEmptyEpiditorParagraph, docShape, documentId, extendedParse, initial, mapOf, number, object, oneOf, optional, sectionDocShape, shape, string, _ref, _ref1;

Code = require('lib/db_docs/field_types/code_type');

documentId = require('lib/db_docs/field_types/document_id');

docShape = require('lib/db_docs/field_types/doc_shape');

_ref = require('lib/db_docs/field_types/type_decorators'), initial = _ref.initial, extendedParse = _ref.extendedParse;

oneOf = require('lib/db_docs/field_types/one_of');

mapOf = require('lib/db_docs/field_types/map_of');

arrayOf = require('lib/db_docs/field_types/array_of');

shape = require('lib/db_docs/field_types/shape');

createEmptyEpiditorParagraph = require('lib/epiditor_utils').createEmptyEpiditorParagraph;

_ref1 = require('lib/db_docs/field_types/built_in_types'), boolean = _ref1.boolean, number = _ref1.number, object = _ref1.object, string = _ref1.string;

optional = shape.typeDecorators.optional;

DOCUMENT_SECTIONS_V2_SECTION_TYPE = require('lib/db_docs/doc_types').DOCUMENT_SECTIONS_V2_SECTION_TYPE;

SECTION_STATUSES = require('lib/document_sections_v2_helper').SECTION_STATUSES;

EditingByInfo = shape({
  timestamp: number,
  user: shape({
    id: string,
    name: string
  })
});

convertFromStringIfNecessary = function(value) {
  if (typeof value === 'string') {
    return {
      "doc": createEmptyEpiditorParagraph(value),
      "selection": {
        "type": "text",
        "anchor": 0,
        "head": 0
      },
      "changeTracker": {
        "changes": {}
      },
      "annotations": {}
    };
  } else {
    return value;
  }
};

sectionDocShape = docShape({
  type: initial(DOCUMENT_SECTIONS_V2_SECTION_TYPE)(string),
  title: string,
  parent: optional(documentId),
  content: optional(extendedParse(convertFromStringIfNecessary)(object)),
  status: optional(oneOf(SECTION_STATUSES)),
  editingBy: optional(EditingByInfo),
  questionId: optional(documentId),
  recommendationId: optional(documentId),
  mdaTableId: optional(documentId),
  selectedAppendices: optional(mapOf(boolean)),
  mdaTopicId: optional(documentId),
  codes: optional(mapOf(Code)),
  sectionType: optional(string),
  visualizationId: optional(string),
  additionalData: optional(object),
  refIds: optional(arrayOf(documentId)),
  references: optional(object),
  options: optional(object),
  docSecRootId: optional(documentId)
});

module.exports = sectionDocShape;
